import {useFeatures} from '@udemy/react-experimentation-provider';

import {JBI_ENHANCED_LECTURE_UNIT} from 'src/lib/experimentation-constants';
import {getJbiEnhancedLectureVariant} from 'src/lib/jbi-enhanced-lecture-unit';

export function useJbiEnhancedLectureUnit() {
    const {featureVariantAssignments, isLoading} = useFeatures([JBI_ENHANCED_LECTURE_UNIT]);
    const assignment = featureVariantAssignments.get(JBI_ENHANCED_LECTURE_UNIT);
    const variant = isLoading ? undefined : getJbiEnhancedLectureVariant(assignment);

    return {
        isLoading,
        variant,
    };
}
